import React from "react";
import {
  Box,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import HireInvitations from "../../HireInvitations";

const OpportunitiesSection = () => (
  <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      sx={{ p: 2.5 }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 850, lineHeight: 1.2 }}>
            Opportunities
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Review client invitations, share availability, and track decisions.
          </Typography>
        </Box>
      </Stack>
    </Stack>

    <Divider />

    <Box sx={{ p: 2.5 }}>
      <HireInvitations embedded />
    </Box>
  </Paper>
);

export default OpportunitiesSection;
